'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import { makeAsyncComponentWithOverlay } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { getIsOnboardingActive } from 'EmailEditorUI/redux/selectors/OnboardingSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const _AsyncOnboardingContainer = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: 'onboarding-container' */'EmailEditorUI/containers/OnboardingContainer'));
class AsyncOnboardingContainer extends Component {
  render() {
    if (!this.props.isOnboardingActive) {
      return null;
    }
    return /*#__PURE__*/_jsx(_AsyncOnboardingContainer, Object.assign({
      inContentIframeContext: true
    }, this.props));
  }
}
export default connect(state => ({
  isOnboardingActive: getIsOnboardingActive(state)
}))(AsyncOnboardingContainer);